var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.058 7.02c-2.684-2.766-5.793-1.6-7.717-.366-1.088.697-2.594.697-3.682 0-1.925-1.233-5.033-2.4-7.717.366-6.372 6.563 4.555 19.212 9.558 19.212S31.43 13.583 25.058 7.02z",
    fill: "#FFE14B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.058 7.02c6.372 6.563-4.555 19.212-9.558 19.212S-.43 13.583 5.942 7.02c2.684-2.765 5.792-1.6 7.717-.366 1.088.697 2.594.697 3.682 0 1.924-1.233 5.033-2.4 7.717.366z",
    stroke: "#FFE14B",
    strokeWidth: 2.091
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.b29c1fad4d9a7f6fe1049cc834ddefab.svg";
export { ForwardRef as ReactComponent };